import React from "react";
import "./Header.css";

export default function Header() {
  return (
    <header>
      <h1 className="site-title">Emoji Hub - click to copy!</h1>
    </header>
  );
}
